import { render, staticRenderFns } from "./VerificaIscrizione.vue?vue&type=template&id=74d2782e&scoped=true"
import script from "./VerificaIscrizione.vue?vue&type=script&lang=js"
export * from "./VerificaIscrizione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d2782e",
  null
  
)

export default component.exports